<template>
  <div :style="`border-bottom: ${filterBorderBottomColor} 1px solid;`" class="filters-container mb-0 pb-0">
    <div class="storefront-sidebar-filters-title" @click="collapse">
      <h6 class="row m-0 align-items-center mb-0">
        <div style="width: 32px">
          <SidebarCategoryIcon
            v-if="icon == 'category'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <FeaturedIcon v-else-if="icon == 'star'" class="" type="outline" :fill="iconColor" style="width: 1rem; height: 1rem" />
          <SidebarStrainIcon
            v-else-if="icon == 'strain'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <SidebarProductTypeIcon
            v-else-if="icon == 'product-type'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <SidebarCannaIcon
            v-else-if="icon == 'canna'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <SidebarBrandIcon
            v-else-if="icon == 'brand'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
          <SidebarMedRecIcon
            v-else-if="icon == 'med/rec'"
            class=""
            :fill="iconColor"
            :svg-style="{
              top: '-1px',
              position: 'relative',
              height: '20px',
              width: '20px',
            }"
          />
        </div>

        <span :style="`color: ${titleColor}`">
          {{ title }}
        </span>
        <i :style="`color: ${titleColor}`" :class="`fa fas fa-angle-${collapsed ? 'up' : 'down'} ml-auto`" />
      </h6>
    </div>
    <b-collapse class="storefront-sidebar-filters" :visible="!collapsed">
      <div class="d-flex mb-3 justify-content-center">
        <div class="btn-group">
          <BushelBtn
            :style="{
              borderColor: filterBorderBottomColor + ' !important',
              fontSize: '12px',
              color: unit !== '%' ? btnTextColor + ' !important' : btnActiveTextColor + ' !important',
              backgroundColor: unit !== '%' ? btnColor + ' !important' : btnActiveColor + ' !important',
            }"
            :class="`btn-sm font-weight-bold ${unit !== '%' ? 'border' : ''}`"
            :flat="unit !== '%' ? true : false"
            @click="onSelectPrecentage"
          >
            %
          </BushelBtn>
          <BushelBtn
            :style="{
              borderColor: filterBorderBottomColor + ' !important',
              fontSize: '12px',
              color: unit !== 'Mg' ? btnTextColor + ' !important' : btnActiveTextColor + ' !important',
              backgroundColor: unit !== 'Mg' ? btnColor + ' !important' : btnActiveColor + ' !important',
            }"
            :class="`btn-sm font-weight-bold ${unit !== 'Mg' ? 'border' : ''}`"
            :flat="unit !== 'Mg' ? true : false"
            @click="onSelectMg"
          >
            Mg
          </BushelBtn>
        </div>
      </div>
      <BushelRangeSlider
        :key="rangeKey"
        :class="rangeSliderClass"
        :style="{ borderColor: filterBorderBottomColor + ' !important' }"
        :min="getMin()"
        :max="getMax()"
        :step="step"
        :disabled="!unit"
        :label-active="rangeSliderLabelActive"
        :thumb-color="iconColor"
        :track-color="filterBorderBottomColor"
        :track-label-color="itemTextColor"
        @input="onInput"
      />

      <slot />
    </b-collapse>
  </div>
</template>
<script>
import SidebarCategoryIcon from "@/components/common/icons/SidebarCategoryIcon.vue";
import SidebarStrainIcon from "@/components/common/icons/SidebarStrainIcon.vue";
import SidebarProductTypeIcon from "@/components/common/icons/SidebarProductTypeIcon.vue";
import SidebarCannaIcon from "@/components/common/icons/SidebarCannaIcon.vue";
import SidebarBrandIcon from "@/components/common/icons/SidebarBrandIcon.vue";
import FeaturedIcon from "@/components/common/icons/FeaturedIcon.vue";
import SidebarMedRecIcon from "@/components/common/icons/SidebarMedRecIcon.vue";
import BushelRangeSlider from "@/components/common/BushelRangeSlider.vue";
import BCollapse from "@/components/base/BCollapse.vue";

export default {
  components: {
    SidebarCategoryIcon,
    SidebarStrainIcon,
    SidebarProductTypeIcon,
    SidebarCannaIcon,
    SidebarBrandIcon,
    SidebarMedRecIcon,
    FeaturedIcon,
    BushelRangeSlider,
    BCollapse,
  },
  props: {
    title: { type: String, required: true },
    icon: { type: String },
    iconColor: { type: String },
    titleColor: { type: String },
    filterBorderBottomColor: { type: String },
    btnColor: { type: String },
    btnActiveColor: { type: String },
    btnTextColor: { type: String },
    btnActiveTextColor: { type: String },
    itemTextColor: { type: String },
    selectedTextColor: { type: String },
    initCollapsed: { type: Boolean, default: true },
    sortingAlg: { type: String },
    percentMin: { type: Number, default: 0 },
    percentMax: { type: Number, default: 150 },
    mgMin: { type: Number, default: 0 },
    mgMax: { type: Number, default: 10000 },
    rangeSliderClass: { type: String, default: "mb-3" },
    rangeSliderLabelActive: { type: String },
    outerLabel: { type: String },
    outerLabelStyle: { type: [String, Object] },
  },
  emits: ["selected"],
  data() {
    return {
      collapsed: this.initCollapsed,
      unit: null,
      rangeKey: 1,
      step: 1,
    };
  },
  methods: {
    getMin() {
      if (this.unit === "%") {
        return this.percentMin;
      }
      if (this.unit === "Mg") {
        return this.mgMin;
      }
      return 0;
    },
    getMax() {
      if (this.unit === "%") {
        return this.percentMax;
      }
      if (this.unit === "Mg") {
        return this.mgMax;
      }
      return 100;
    },
    onSelectPrecentage() {
      this.rangeKey += 1;
      this.step = 1;
      if (this.unit == "%") {
        this.unit = null;
        this.$emit("selected", {
          min: this.getMin(),
          max: this.getMax(),
          unit: null,
        });
      } else {
        this.unit = "%";
        this.$emit("selected", {
          min: this.getMin(),
          max: this.getMax(),
          unit: this.unit,
        });
      }
    },
    onSelectMg() {
      this.rangeKey += 1;
      this.step = 100;
      if (this.unit == "Mg") {
        this.unit = null;
        this.$emit("selected", {
          min: this.getMin(),
          max: this.getMax(),
          unit: null,
        });
      } else {
        this.unit = "Mg";
        this.$emit("selected", {
          min: this.getMin(),
          max: this.getMax(),
          unit: this.unit,
        });
      }
    },
    collapse() {
      this.collapsed = !this.collapsed;
    },
    onInput(range) {
      const payload = { ...range };
      payload.unit = this.unit;
      this.$emit("selected", payload);
    },
  },
};
</script>
<style></style>
